module.exports = __webpack_public_path__ + "media/images/mobile/solutions/3-fa51bc1b4e688e7589969276c593b970.png";